import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, compile, createVNode } from 'vue';

  export interface IProps {
    // 模板code
    code?: string;
    // 注入的数据
    data?: {
      [key: string]: any;
    }
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    code: null,
    data: null
  },
  setup(__props: any) {

const props = __props as {
    // 模板code
    code?: string;
    // 注入的数据
    data?: {
      [key: string]: any;
    }
  }

  const tryCompileCode = (code: string) => {
    try {
      return compile(code);
    } catch (e: any) {
      return () => createVNode('code', {}, e.stack || e.message);
    }
  };

  
  const dynamicComponent = computed(() => {
    const codeStr = (props.code || '')
      .replace(/<style/g, '<component is="style"')
      .replace(/style>/g, 'component>')
      .replace(/<script/g, '<component is="script"')
      .replace(/script>/g, 'component>');
    return {
      data: () => (props.data || {}),
      render: tryCompileCode(codeStr)
    };
  });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(dynamicComponent))))
}
}

})